import { toUTCfromMoment } from 'api/helpers';
import { HOURS_RANGE } from 'config/constants';
import { API_DATE_FORMAT_WITH_TIME } from 'config/api';
import moment from 'moment';
import he from 'he';

export default class OrderDetailsProduct {
	static getQuantityValue = quantity => (quantity === 0 ? '' : quantity);

	quantity = null;
	unit_price = null;
	description = null;
	line_number = null;
	product_number = null;
	planned_deliv_date = null;

	checkDate(plannedDeliveryDate) {
		const plannedDeliveryDateInitial = moment(
			plannedDeliveryDate,
			API_DATE_FORMAT_WITH_TIME
		);

		const currentDateLocal = moment.utc();

		const offset = moment().utcOffset();
		const currentDateUTC = toUTCfromMoment(currentDateLocal, offset);

		const currentDateUTCFormat = moment(
			currentDateUTC,
			API_DATE_FORMAT_WITH_TIME
		);

		const differenceHours = plannedDeliveryDateInitial.diff(
			currentDateUTCFormat,
			'hours'
		);

		if (differenceHours < HOURS_RANGE) {
			return currentDateLocal.local();
		}
		return plannedDeliveryDateInitial;
	}

	constructor(product) {
		this.quantity = OrderDetailsProduct.getQuantityValue(
			product.QuantityOrdered
		);
		this.unit_price = product.UnitPrice;
		this.description = he.decode(product.Description);
		this.line_number = product.LineNumber;
		this.product_number = product.ItemNumber;
		this.planned_deliv_date = this.checkDate(product.PlannedDeliveryDate);
	}
}



// WEBPACK FOOTER //
// ./src/api/models/OrderDetailsProduct.js